<template>
  <v-data-iterator
    :items="invoices.data"
    :page.sync="c_page"
    :items-per-page.sync="c_size"
    :server-items-length="invoices.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-invoice-card v-for="(invoice, index) in slot.items"
        :invoice="invoice"
        :key="index"
        @edit="$emit('edit', invoice)"
      />
    </template>
  </v-data-iterator>
</template>


<script>

  export default {

    components: {
      'im-invoice-card': () => import('@/components/Invoice/InvoiceCard')
    },

    props: {
      invoices: Object
    },

    data: () => ({
      pagination: {
        page: 1,
        size: 10,
      },
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    computed: {
      c_page: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: val,
            size: this.pagination.size,
          })
        }
      },
      c_size: {
        get() {
          return this.pagination.size;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: this.pagination.page,
            size: val
          })
        }
      }
    }
  }

</script>